// src/pages/VerifyRedirect.tsx

import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const VerifyRedirect = () => {
  const [params] = useSearchParams();
  const [result, setResult] = useState<any>(null);

  useEffect(() => {
    const identityVerificationId = params.get('identityVerificationId');
    if (!identityVerificationId) {
      alert('인증 ID가 없습니다.');
      return;
    }

    fetch('https://api-4iuywcitfq-uc.a.run.app/api/verify-identity', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ identityVerificationId }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) throw new Error(data.error);
        setResult(data);
      })
      .catch(err => {
        console.error('❌ 인증 정보 조회 실패:', err);
        alert('인증 정보 조회 실패');
      });
  }, [params]);

  return (
    <div style={{ padding: '2rem' }}>
      <h2>🔐 본인인증 결과</h2>
      {result ? (
        <ul>
          <li>이름: {result.name}</li>
          <li>전화번호: {result.phone}</li>
          <li>생년월일: {result.birthDate}</li>
        </ul>
      ) : (
        <p>인증 결과를 불러오는 중...</p>
      )}
    </div>
  );
};

export default VerifyRedirect;
